import { Skeleton, TableCell, TableRow } from "@mui/material";
import times from "lodash/times";

export type SkeletonTableRowProps = {
  rows: number;
  cellsPerRow: number;
};

export const SkeletonTableRow = (props: SkeletonTableRowProps) => {
  return times(props.rows, (i) => (
    <TableRow key={i}>
      {times(props.cellsPerRow, (n) => (
        <TableCell key={n}>
          <Skeleton />
        </TableCell>
      ))}
    </TableRow>
  ));
};
